import React from "react";
import { FormattedMessage } from "react-intl";
import Card from "components/Card";
import { Col } from "components/Containers";
import DisplayBox from "components/DisplayBox";
import { ProgressChecklist } from "components/Progress";
import { useRoleBuilderContext } from "hooks";
import { getRoleBuilderSteps, getRoleBuilderSummary } from "constants/index";

/**
 * BuilderSidebar
 *
 * Where the role builder stands and what it has captured so far. Reads the builder from its context.
 */
const BuilderSidebar = () => {
  const { activeStep, companyName, companyUrl, summaryRole } = useRoleBuilderContext();

  return (
    <Col gap="2rem">
      <Card>
        <ProgressChecklist
          title="Missions.Roles.TalentSimple.RoleBuilder.Steps.Title"
          steps={getRoleBuilderSteps(activeStep)}
        />
      </Card>
      <Card>
        <DisplayBox
          title={<FormattedMessage id="Missions.Roles.TalentSimple.RoleBuilder.Summary.Title" />}
          data={getRoleBuilderSummary(activeStep, { companyName, companyUrl, role: summaryRole })}
        />
      </Card>
    </Col>
  );
};

export default BuilderSidebar;
